export default class executionController {

   constructor ($scope, $rootScope, WorkPlanSrv, $mdDialog, GlobalConfig, $cookies, $sessionStorage) {
      this.WorkPlanSrv = WorkPlanSrv
      this.$mdDialog = $mdDialog
      $rootScope.fullscreenClass = 'background-planning'
      this.messagesList = []
      this.routes = GlobalConfig.modulesRoutes
      this.currentUser = JSON.parse($cookies.get('currentUser'))
      this.userId = this.currentUser.id
      //this.workPlanGeneralList = $sessionStorage.workPlanGeneralList
      this.$sessionStorage = $sessionStorage

      this.assignStyles = () => {
         switch(this.timeline) {
            case 1:
               this.classCircleGreen1 = 'green'
               break
            case 2:
               this.classCircleGreen1 = 'green'
               this.classBarGreen1 = 'green'
               break
            case 3:
               this.classCircleGreen1 = 'green'
               this.classCircleGreen2 = 'green'
               this.classBarGreen1 = 'green'
               break
            case 4:
               this.classCircleGreen1 = 'green'
               this.classCircleGreen2 = 'green'
               this.classCircleGreen3 = 'green'
               this.classBarGreen1 = 'green'
               this.classBarGreen2 = 'green'
               break
            case 5:
               this.classCircleGreen1 = 'green'
               this.classCircleGreen2 = 'green'
               this.classCircleGreen3 = 'green'
               this.classBarGreen1 = 'green'
               this.classBarGreen2 = 'green'
               this.classBarGreen3 =' green'
               break
            case 6:
               this.classCircleGreen1 = 'green'
               this.classCircleGreen2 = 'green'
               this.classCircleGreen3 = 'green'
               this.classCircleGreen4 = 'green'
               this.classBarGreen1 = 'green'
               this.classBarGreen2 = 'green'
               this.classBarGreen3 = 'green'
               break
            case 7:
               this.classCircleGreen1 = 'green'
               this.classCircleGreen2 = 'green'
               this.classCircleGreen3 = 'green'
               this.classCircleGreen4 = 'green'
               this.classBarGreen1 = 'green'
               this.classBarGreen2 = 'green'
               this.classBarGreen3 = 'green'
               break
            default:
         }
       }
      this.activate()
   }

   activate () {
      this.getElements()
   }

   getElements () {
      //if(this.workPlanGeneralList == undefined){
         this.WorkPlanSrv.getElementsRightBar.getList({teacherId: this.currentUser.teacherId}).$promise.then((dataReturn) => {
            if (dataReturn.status == true) {
               //this.$sessionStorage.workPlanGeneralList = dataReturn.data
               this.RightBar = dataReturn.data
               this.percentage = this.RightBar.asignaturesPlaned[0].percentage
               this.timeline = parseInt(this.RightBar.timeline[0].stageId)
               for (var i = this.RightBar.asignaturesPlaned.length - 1; i >= 0; i--) {
                  if(this.RightBar.asignaturesPlaned[i].submoduleId == this.routes[i].id){  
                     this.RightBar.asignaturesPlaned[i].route = this.routes[i].route
                  }
               }
            }
            this.assignStyles()
         })
      /*}else{
         this.RightBar = this.workPlanGeneralList
         this.percentage = this.RightBar.asignaturesPlaned[0].percentage
         this.timeline = parseInt(this.RightBar.timeline[0].stageId)
         for (var i = this.RightBar.asignaturesPlaned.length - 1; i >= 0; i--) {
            if(this.RightBar.asignaturesPlaned[i].submoduleId == this.routes[i].id){  
               this.RightBar.asignaturesPlaned[i].route = this.routes[i].route
            }
         }
      }*/     
      this.getMessages()
   }

   getMessages () {
      this.WorkPlanSrv.getMessagesNotification.get({userId: this.userId}).$promise.then((dataReturn) => {
         if (dataReturn.status === true) {
            this.messagesList = dataReturn.data
         } else {
            this.messagesList = []
         }
      })
   }

   showModalMessages () {
      let userId = this.userId
      let messagesList = this.messagesList
      this.$mdDialog.show({
         controller: ['$scope', '$mdDialog','WorkPlanSrv', function showModalMessages ($scope, $mdDialog,WorkPlanSrv) {
            var modalMessagesVm = this

            // declaracion de variables
            modalMessagesVm.userId = userId
            modalMessagesVm.messagesList = messagesList
            modalMessagesVm.class1 = 'mdi-hardware-keyboard-arrow-down'
            modalMessagesVm.class2 = 'mdi-hardware-keyboard-arrow-up'
            modalMessagesVm.classRead = 'mdi-content-drafts'
            modalMessagesVm.classUnRead = 'mdi-content-mail'

            // declaracion de funciones
            modalMessagesVm.showMessage = showMessage
            modalMessagesVm.close = close

            function showMessage(pos) {
               if (modalMessagesVm.messagesList[pos].isHiden) {
                  modalMessagesVm.messagesList[pos].isHiden = false
               } else {
                  modalMessagesVm.messagesList[pos].isHiden = true
               }
            }

            function updateReadMessage(){
               WorkPlanSrv.updateReadingMessages.update({userId: modalMessagesVm.userId}).$promise.then(function (dataReturn) {
                  if (dataReturn.status) {
                     for (var i = modalMessagesVm.messagesList.length - 1; i >= 0; i--) {
                        modalMessagesVm.messagesList[i].isRead = 1
                     }
                  } else {
                     console.log('error de comunicacion con el servidor')
                  }
               }, function (data) {
                  console.log(data)
               })
            }

            function close(){
               $mdDialog.hide()
            }
         }],
         template: require('./modals/messagesModal.html'),
         controllerAs: 'modalMessagesVm',
         clickOutsideToClose: false
      })
   }
    
}
executionController.$inject = ['$scope', '$rootScope', 'WorkPlanSrv', '$mdDialog', 'GlobalConfig', '$cookies', '$sessionStorage']


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/executionCtrl.js